import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import EngagementTable from "./EngagementTable";

function EngagementsTabs(props) {
  const { urlStartDate, urlEndDate, activeTab, setActiveTab } = props;
  const navigate = useNavigate();
  const handleTabChange = (tabKey) => {
    if (props.slotBooking) {
      navigate(
        `/slot-booking-total?tab=${tabKey}&startDate=${urlStartDate}&endDate=${urlEndDate}`
      );
      setActiveTab(tabKey);
      return;
    }
    setActiveTab(tabKey);
    navigate(
      `/engagementReport?tab=${tabKey}&startDate=${urlStartDate}&endDate=${urlEndDate}`
    );
  };
  return (
    <div>
      {props.slotBooking ? (
        <Tabs
          variant="pills"
          defaultActiveKey="slot_booking"
          activeKey={activeTab}
          onSelect={handleTabChange}
          id="controlled-tab-example"
          className="mb-3  border-bottom pb-2"
        >
          <Tab
            eventKey="slot_booking_total"
            title="Slot Booking Total"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab eventKey="retention" title="Retention" className="border">
            <EngagementTable props={props} />
          </Tab>
        </Tabs>
      ) : (
        <Tabs
          variant="pills"
          defaultActiveKey="slot_booking"
          activeKey={activeTab}
          onSelect={handleTabChange}
          id="controlled-tab-example"
          className="mb-3  border-bottom pb-2"
        >
          <Tab eventKey="slot_booking" title="Slot Booking" className=" ">
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="slot_booking_total"
            title="Slot Booking Total"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="ivr_booking"
            title="Ivr EngagementsTabs"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="prescription_call"
            title="Prescription Call"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab eventKey="week_1" title="Week #1" className="border">
            <EngagementTable props={props} />
          </Tab>
          <Tab eventKey="week_3" title="Week #3" className="border">
            <EngagementTable props={props} />
          </Tab>
          <Tab eventKey="retention" title="Retention" className="border">
            <EngagementTable props={props} />
          </Tab>
          <Tab eventKey="adhoc_call" title="Adhoc Call" className="border">
            <EngagementTable props={props} />
          </Tab>
          <Tab eventKey="concern_call" title="Concern Call" className="border">
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="SLOT_BOOKING_MEDICAL"
            title="Slot Booking Medical"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="abandoned_cart"
            title="Abandon Cart"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="repeat_retention"
            title="Repeat Retention"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab eventKey="w0_call" title="W0-Call" className="border">
            <EngagementTable props={props} />
          </Tab>
          <Tab eventKey="forced_slot" title="Forced-Slot" className="border">
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="kit_not_started"
            title="Kit Not Started"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="scalpie_update"
            title="Scalpie Update"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <EngagementTable props={props} />
          <Tab
            eventKey="customer_complaint_booking"
            title="Customer Complaint Booking"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
          <Tab
            eventKey="chat_slot_booking"
            title="Chat slot Booking"
            className="border"
          >
            <EngagementTable props={props} />
          </Tab>
        </Tabs>
      )}
    </div>
  );
}

export default EngagementsTabs;
